import { render, staticRenderFns } from "./InspectionShipmentEdit.vue?vue&type=template&id=03554a5e&"
import script from "./InspectionShipmentEdit.vue?vue&type=script&lang=js&"
export * from "./InspectionShipmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./InspectionShipmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports